import moment from "moment";
import { AnnualLeaveKey } from "@/constants/globalConstants";
export class Adjustment {
  UserID;
  DateTx;
  TxType;
  EventDesc;
  TxDesc;
  LeaveType;
  QtyDaysHrs;
  DaysAdd;
  HoursAdd;
  DaysDeduct;
  HoursDeduct;
  AddBy;
  constructor() {
    this.UserID = "";
    this.DateTx = moment().format("YYYY-MM-DD hh:mm:ss");
    this.TxType = "ADJ";
    this.EventDesc = "";
    this.TxDesc = "";
    this.LeaveType = AnnualLeaveKey;
    this.QtyDaysHrs = 1;
    this.DaysAdd = 0;
    this.HoursAdd = 0;
    this.DaysDeduct = 0;
    this.HoursDeduct = 0;
    this.AddBy = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/Adjustment.js